import React from 'react'

const CheckboxInput = React.forwardRef((props, ref) => (
  <label className='team-checkbox-label'>
    <input type='checkbox' {...props} ref={ref} />
    {props.label}
  </label>
))

export default CheckboxInput
